import {Editor, Transforms} from "../../../../../../pkg/slate.js";
export const replaceNode = (editor, newNode, at) => {
  Editor.withoutNormalizing(editor, () => {
    Transforms.removeNodes(editor, {at});
    Transforms.insertNodes(editor, newNode, {at});
  });
};
